module.exports = __webpack_public_path__ + "img/mov.f69d690a.svg";